const FETCH_CREDITS = 'fetch_credits';
const FETCH_CREDIT = 'fetch_credit';
const DELETE_CREDIT = 'delete_credit';
const PERSIST_CREDIT = 'persist_credit';
export default {
    FETCH_CREDITS,
    FETCH_CREDIT,
    DELETE_CREDIT,
    PERSIST_CREDIT,
};
